module.exports = __webpack_public_path__ + "static/fluent-python-81c4b162fd663fb56ec3d81c8466fc60.jpg";